import * as React from "react";
import { SpinnerBlock } from "../../common/Spinner";
import { useParams } from "react-router-dom";
import { routes } from "../../../appRoutingHelpers";
import { OrderTimeline } from "./order-cards/order-timeline/OrderTimeline";
import { OrderDetails } from "./order-cards/OrderDetails";
import { OrderDeliveryInformation } from "./order-cards/OrderDeliveryInformation";
import { OrderSummary } from "./order-cards/order-summary/OrderSummary";
import { GoBackLinkButton } from "../../../components/GoBackLinkButton";
import { useSelector } from "react-redux";
import * as authSelectors from "../../auth/authSelectors";
import { useHandleFetchError } from "../../../error-handler";
import { useGetOrder } from "./service/order-api";
import { OrderPayments } from "./order-cards/OrderPayments";

interface Props {}

export const OrderShow: React.FC<Props> = () => {
  const { id } = useParams<{
    id: string;
  }>();
  const organization = useSelector(authSelectors.selectedOrganizationKeyName);

  const { data: order, isLoading, error: getOrderError } = useGetOrder(
    organization,
    id
  );

  const showDeliveryCard = order?.delivery !== undefined;

  useHandleFetchError(getOrderError);

  if (isLoading || !order) {
    return <SpinnerBlock />;
  }

  return (
    <div className="container mt-5">
      <GoBackLinkButton
        to={routes.orderList(organization)}
        text="Back to all orders"
      />
      <div className="row">
        <div className="col-12 col-lg-4">
          <OrderTimeline order={order} />
        </div>
        <div className="col-12 col-lg-8">
          <OrderDetails
            order={order}
            linkRoute={routes.userProfile(organization, order?.customer.id!)}
          />
          <OrderPayments order={order} />
          {showDeliveryCard && <OrderDeliveryInformation order={order} />}
          <OrderSummary order={order} />
        </div>
      </div>
    </div>
  );
};

export default OrderShow;
